import { useState, type ReactNode } from "react";
import { faviconUrlForOrigin } from "~/lib/favicon";

export function WebsiteToolIcon({
  pageUrl,
  fallback,
}: {
  pageUrl?: string | undefined;
  fallback: ReactNode;
}) {
  const src = faviconUrlForOrigin(pageUrl);
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  return src && src !== failedSrc ? (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      referrerPolicy="no-referrer"
      className="size-4 shrink-0 rounded-sm"
      onError={() => setFailedSrc(src)}
    />
  ) : (
    fallback
  );
}
